<template>
  <Toast/>
  <div class="row">
    <div v-if="modifierParent=='true'">
      <h2 class="titre">Ajouter un intervenant (parent intervenant) et son profil (intervenant)</h2>
    </div>
    <div v-else>
      <h2 class="titre">Ajouter un profil (intervenant)</h2>
    </div>
    <InformationParentIntervenant :intervenant="intervenant" :modifierParent="modifierParent"
                                  ref="informationParentIntervenant"/>
    <InformationIntervenant :intervenant="intervenant" ref="informationIntervenant"/>
    <div class="row">
      <div class="col">
        <Button label="Ajouter" v-on:click="ajouter"/>
      </div>
      <div class="col">
        <Button label="Fermer" v-on:click="fermer"/>
      </div>
    </div>
  </div>
</template>
<script>

import {mapGetters} from "vuex";
import axios from "axios";
import InformationIntervenant from "@/components/pilotage/intervenant/Consulter/InformationIntervenant.vue";
import InformationParentIntervenant from "@/components/pilotage/intervenant/Consulter/InformationParentIntervenant.vue";

export default {
  name: "AjouterIntervenant",
  components: {
    InformationParentIntervenant,
    InformationIntervenant,
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      intervenant: 'pilotage/intervenant'
    })
  },
  data() {
    return {
      modifierParent: null,
    };
  },
  beforeMount() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.modifierParent = this.$route.params.modifierParent;
    this.$root.$refs.breadcrumbComp.ajout("Ajouter Intervenant");
    this.getIntervenant()
  },
  methods: {
    getIntervenant() {
      this.$store.commit('pilotage/INTERVENANT_STORE_STATE_RESET');
      if (this.modifierParent != 'true') {
        this.$store.dispatch('pilotage/consulterIntervenantAction', {cle: this.$route.params.cle})
            .then((res) => {
              this.$store.commit('pilotage/UPDATE_INTERVENANT', res.data);
              this.$refs.informationIntervenant.resetIntervenant();
              this.$refs.informationParentIntervenant.setIntervenantParent(res.data.intervenantCommunVO);
              this.estParent = res.data.compteParent;
            });
      }
    },
    ajouter() {
      this.$store.commit('pilotage/UPDATE_INTERVENANT', this.$refs.informationIntervenant.getIntervenant());
      this.intervenant.intervenantCommunVO = this.$refs.informationParentIntervenant.getIntervenantParent();
      this.$store.dispatch('pilotage/ajouterIntervenantAction', this.intervenant)
          .then((res) => {
            this.$root.$refs.messagesComp.messagesList = res.data.messageVOs;
            if (res?.data?.messageVOs.length == 0) {
              this.$toast.add({
                severity: 'success',
                summary: 'Ajouter',
                detail: 'Ajout enregistré.',
                life: 6000
              });
              this.consulter(res.data.entite.cleIntervenant);
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Ajouter',
                detail: 'L\'ajout n\'a pas été enregistré.',
                life: 6000
              });
            }
          });
    },
    consulter(cle) {
      this.$router.push({
        name: "consulterIntervenantPilotage",
        params: {cle: cle},
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  },

}

</script>